export const DEFAULT_SERVER_URL_KEY = "opencode.settings.dat:defaultServerUrl"

export function readStoredServerUrl(): string | null {
  if (typeof localStorage === "undefined") return null
  try {
    return localStorage.getItem(DEFAULT_SERVER_URL_KEY)
  } catch {
    return null
  }
}

export function writeStoredServerUrl(url: string | null): void {
  if (typeof localStorage === "undefined") return
  try {
    if (url !== null) {
      localStorage.setItem(DEFAULT_SERVER_URL_KEY, url)
      return
    }
    localStorage.removeItem(DEFAULT_SERVER_URL_KEY)
  } catch {
    return
  }
}

export function readHostParam(search: string): string | null {
  const params = new URLSearchParams(search)
  const host = params.get("host")
  if (!host) return null
  try {
    const url = new URL(host)
    if (url.protocol !== "http:" && url.protocol !== "https:") return null
    return url.origin
  } catch {
    return null
  }
}

export function readAuthTokenParam(search: string): string | null {
  return new URLSearchParams(search).get("auth_token")
}

export function stripQueryParams(search: string, keys: string[]): string {
  const params = new URLSearchParams(search)
  let changed = false
  for (const key of keys) {
    if (params.has(key)) {
      params.delete(key)
      changed = true
    }
  }
  if (!changed) return search
  const remaining = params.toString()
  return remaining ? `?${remaining}` : ""
}

export function resolveServerUrl(input: {
  stored: string | null
  hostParam: string | null
  hostname: string
  isDev: boolean
  devHost?: string
  devPort?: string
  protocol?: string
}): string {
  if (input.hostParam) return input.hostParam
  if (input.stored) return input.stored
  if (input.hostname.includes("opencode.ai")) return "http://localhost:4096"
  if (input.isDev)
    return `http://${input.devHost ?? "localhost"}:${input.devPort ?? "4096"}`
  const scheme = input.protocol === "https:" ? "https" : "http"
  return `${scheme}://${input.hostname}`
}
